<template>
  <div class="content">
    <s-location notice title="변호사 신분 확인 시스템"/>
<!--     <h4 class="sub_title02">변호사 신분 확인 시스템</h4> -->
   <div class="test_wrap" v-if="isMaster">
     테스트 :
      <span @click="qrcode='2008251054135136740CCD81406476'; doScan()" class="btn">정상 </span>
      <span @click="qrcode='224831ED4BF34A0B9E871E7BFF275F'; doScan()" class="btn">유효하지 않음 (재발급) </span>
      <span @click="qrcode='DCEC88BEC10B4963A5B3D716C78221'; doScan()" class="btn">유효하지 않음 (변호사상태) </span>
      <span @click="qrcode='2006011636496jkldji2uj4oino103'; doScan()" class="btn">존재하지 않음 </span>
   </div>

    <!-- <div class="regno_input">
        <li>등록번호</li>
        <li><input   type="text" title="등록번호" placeholder="등록번호" @keydown.enter="doChange" maxlength="16"/></li>
        <li><div class=" btn blue01" >조회</div></li>
    </div> -->
    <div v-if="isMaster">
      <table class="tbl01 sch_tbl">
        <tr>
          <th>조회대상</th>
          <td>
            <label><input type="radio" v-model="searchType" value="1">변호사</label>
            <label><input type="radio" v-model="searchType" value="2">외국법 자문사</label>
          </td>
          <th>등록번호</th>
          <td>
            <input type="text" class="sch_input" v-model="inputnum" maxlength="5" placeholder="등록번호" @keyup.enter="doScan()"/>
            <button @click="doScan" class="btn scan_btn">조회</button>
          </td>
        </tr>
      </table>
        (디버깅) qrcode = {{ qrcode }}
    </div>
    <div :class="`scan_board ${hasFocus ? '' : 'no_ready'}`" :style="`background-color:${hasFocus ? '#f3f3f3' : '#a80909'}`">
      <p class="focus" :style="`color:${hasFocus ? 'black' : 'white'}`"> {{ hasFocus ? '스캔이 준비됨' : '스캔이 준비되지 않음. 여기를 클릭해 주세요.' }}</p>


      <template v-if="status == 'ready'">
        대기중 입니다.
      </template>

      <template v-if="status == 'loading'">
        회원정보를 조회중 입니다.
      </template>

      <template v-if="status == 'error'">
        <div class="err_red mt20" v-html="msg"></div>
      </template>

      <template v-if="status == 'ok'">
        <table class="tbl01 scan_tbl">
          <tr>
            <td>
              <img :src="sitem.path" class="picture">
            </td>
            <td>
              등록번호 : {{sitem.INPUTNUM}}
              <br/>
              성 &nbsp; &nbsp; &nbsp; 명 : {{sitem.NAME}}
            </td>
          </tr>
        </table>
      </template>

    </div>
	</div>
</template>
<script>

let ui
export default {
  data() {
    return {
      sitem  : {},
      qrcode : '',
      inputnum   : '',  // 등록번호
      searchType : '1', // 조회대상
      hasFocus : true, // 포커스 여부
      msg   : '',      // 오류 메시지
      status: 'ready', // 상태
      timer : null,
    }
  },
  computed: {
    isMaster() { return _.isEqual(this.$store.state.session.user.userkind, "변협관리자") }
  },
  created() {
    ui = this.$ui
    window.addEventListener('keyup', this.qrcodeKeyPress) // 키보드 이벤트 등록
    window.addEventListener('focus', this.myFocusIn)      // 포커스인 이벤트 등록
    window.addEventListener('blur', this.myFocusOut)      // 포커스아웃 이벤트 등록
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.qrcodeKeyPress) // 키보드 이벤트 해제
    window.removeEventListener('focus', this.myFocusIn)      // 포커스인 이벤트 해제
    window.removeEventListener('blur', this.myFocusOut)      // 포커스아웃 이벤트 해제
  },
  mounted() {
    ui.httpGet('/mypage/set_scan_mode', {}, ()=>{});
  },
  methods: {
    myFocusIn(e) {
      this.hasFocus = true
      document.body.style.backgroundColor = "#ffffff";
    },
    myFocusOut(e) {
      this.hasFocus = false
      document.body.style.backgroundColor = "#a80909";
    },
    qrcodeKeyPress(e) {
      if (e.altKey || e.ctrlKey) return // alt 또는 ctrl 눌린거는 취급 안함

      var k = e.keyCode

      // console.log(e);
      // console.log(e.keyCode);
      // console.log(e.key);

      if (k == 13) { // 엔터
        this.doScan();
      } else if (k >= 65 && k <= 90 || k >= 48 && k <= 57) { // a-Z || 0-9

        if (this.qrcode === undefined) this.qrcode = ''
        this.qrcode = this.qrcode + e.key
        //console.log("e.key : " + e.key + " :: " + this.qrcode);
        if (this.qrcode.length >= 30) { // 또는 30자가 되면
          this.doScan();
        } else {

          // console.log("타이머 체크");
          if (this.timer) {
            // console.log("타이머 있음. -- 클리어!!!");
            window.clearTimeout(this.timer)
            this.timer = null
          } else {
            // console.log("타이머 없음. -- 아무것도 안함");
          }

          var self = this

          this.timer = setTimeout(() => {
            // console.log("self.qrcode = " + self.qrcode);
            self.qrcode = ''
            // console.log("self.qrcode 클리어");
          }, 100);


        }
      }
    },
    doScan() {

      console.log(this.qrcode);

      // 등록번호 조회
      if (this.qrcode.length < 30 && this.inputnum.length < 4) return // 큐알코드가 30자보다 짧고, 등록번호가 4자보다 짧으면 조회 안함
      if (this.qrcode.length < 30 && this.inputnum.length > 4) { // 큐알코드가 30자보다 짧고, 등록번호가 4자 이상이면 => 등록번호로 검색
        this.qrcode = ''
      }

      // qrcode 글자 수에 따른 처리
      // if (this.qrcode.length < 30) return // 30자보다 짧으면 조회 안함
      if (this.qrcode.length > 30) { // qrcode가 30자 넘으면 => 큐알코드로 검색
        this.qrcode = this.T.substring(this.qrcode, this.qrcode.length-30, this.qrcode.length) // 30자보다 길면 뒤에서 30자만 잘라냄
        this.inputnum = '' // 등록번호는 삭제
      }

      var sendInputnum = this.inputnum
      var sendQrcode = this.qrcode
      this.inputnum = ''
      this.qrcode = ''
      this.status = 'loading'
      this.sitem = {}
      ui.httpGet('/qrcode/scan' , { QRCODE: sendQrcode, INPUTNUM: sendInputnum, SEARCHTYPE: this.searchType },
        ret => {
          // console.log(ret)
          const {msg, status} = ret.data

          if (status == '0') { // QRCODE 스캔 성공
            this.status = 'ok'
            this.sitem = ret.data.item
          } else {
            this.status = 'error'
            this.msg = msg
          }
      })
    },
  },
}
</script>
<style scoped>
.picture { margin:2px auto; text-align: center; background: #fff; padding:10px; border-radius: 5px; height:400px;}
.err_red { color: #ffa400eb; font-weight: bold; font-size: 30px; }
.scan_board { clear:both;position:relative;display:inline-block;background-color: #f3f3f3;   text-align: center; font-weight: normal;
              width:100%;min-height: 570px;box-sizing: border-box; margin:0px auto; font:14px 'NanumSquare'; word-break: keep-all}
.scan_board .focus { color: white; font-weight: bold; font-size: 30px;  padding:30px 0;}
.no_ready tr td { color:#fff;}

.scan_tbl td { padding:20px 0; font-size:32px; }
.scan_tbl td {border:none;}
.scan_tbl td:first-child {text-align: right;}
.scan_tbl td:last-child {text-align: left; padding-left:50px;}

.regno_input { font-size:28px; margin:20px auto; text-align: center; display:inline-block; position: relative; width:100%;}
.regno_input li:first-child { margin-right:30px;}
.regno_input li {float:left; line-height:43px; }
.regno_input input { height:43px; font-size:28px; }
.regno_input div {font-size:28px; font-weight: normal;}

.test_wrap { position: absolute; margin-top: -130px; margin-left: 390px;  font-size: 15px; font-weight: bold; color: red;}
.test_wrap .btn { padding: 2px 10px;; min-width: 0;  margin-right: 5px; background-color: #fff;}
.scan_btn { font-size: 15px; font-weight: bold; padding: 2px 10px;; min-width: 0;  margin-right: 5px; background-color: #fff;}
</style>